import React, { createContext, useContext, useState } from 'react';

// Create a context for the selected array
const SelectedPermissionsContext = createContext();

// Create a provider component
export const SelectedPermissionsProvider = ({ children }) => {
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const addToSelectedPermissions = (item) => {
    setSelectedPermissions((prevSelected) => {
      const exists = prevSelected.some(
        (permission) => permission.id === item.id
      );
      if (exists) {
        return prevSelected;
      }
      return [item, ...prevSelected];
    });
  };

  const removeFromSelectedPermissions = (obj) => {
    setSelectedPermissions((prevSelected) =>
      prevSelected.filter((item) => item.id !== obj)
    );
  };

  const resetSelectedPermissions = () => {
    setSelectedPermissions([]);
  };

  return (
    <SelectedPermissionsContext.Provider
      value={{
        selectedPermissions,
        addToSelectedPermissions,
        removeFromSelectedPermissions,
        resetSelectedPermissions,
        setSelectedPermissions,
      }}>
      {children}
    </SelectedPermissionsContext.Provider>
  );
};

// Create a custom hook to use the selected context
export const useSelectedPermissions = () => {
  return useContext(SelectedPermissionsContext);
};
